export * from './ie-detection.component';
